/**
 * Formats a work order's required-by date as "20 Mar 2026" (en-GB).
 * Returns "—" for null, empty, or unparseable input.
 */
export function formatRequiredBy(iso: string | null): string {
  if (!iso) return '—';

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
